

/* tslint:disable */



export enum ActivityType {
    EditGuideline = 1,
    ChangeGuidelineStatus = 2,
    LoadGuideline = 3,
    ViewGuideline = 4,
    RemoveGuideline = 5,
    UserLogin = 6,
    ViewPublicGuideline = 7,

}


